export default __webpack_public_path__ + "8e2f786cfb390f87f2886d2d6459fef4.png";